import { render, staticRenderFns } from "./QTabDropdown.vue?vue&type=template&id=dd57b108&"
import script from "./QTabDropdown.vue?vue&type=script&lang=js&"
export * from "./QTabDropdown.vue?vue&type=script&lang=js&"
import style0 from "./QTabDropdown.vue?vue&type=style&index=0&id=dd57b108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports